import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import HeroSection from './Landingpages/HeroSection';
import WhyChooseSolar from './Landingpages/WhyChooseSolar';
import SolarCalculator from './Landingpages/SolarCalculator';
import Services from './Landingpages/Services';
import HowItWorks from './Landingpages/HowItWorks';
import ProjectGallery from './Landingpages/ProjectGallery';
import Testimonials from './Landingpages/Testimonials';
import SubsidySection from './Landingpages/SubsidySection';
import FAQ from './Landingpages/FAQ';
import ContactCTA from './Landingpages/ContactCTA';

const Home = () => {
  return (
    <div className="font-sans antialiased overflow-x-hidden">
      {/* <Navbar /> */}
      <main>
        <HeroSection />
        <WhyChooseSolar />
        <HowItWorks />
        {/* <ProjectGallery /> */}
        <Testimonials />
        <SubsidySection />
        <FAQ />
        <ContactCTA />
      </main>
      {/* <Footer /> */}
    </div>
  );
};

export default Home;